import styled from 'styled-components';
import { media } from '~/styles/mixins';
import ResponsiveText from '~/components/ResponsiveText';

export const CardWrapper = styled.div`
	position: relative;
	flex: 1;
	display: flex;
	flex-direction: column;
	padding: 24px 0;

	${media.large`
		padding: 36px 0;
	`}
`;

export const Card = styled('div')<{ isCompetitor: boolean }>`
	display: flex;
	height: 100%;
	flex-direction: column;
	align-items: flex-start;
	border-radius: 16px;
	background-color: ${({ theme, isCompetitor }) =>
		isCompetitor
			? theme.tokens.COLOR_TOKENS_FILL_INVERTIBLE_NEUTRAL_NEUTRAL_ULTRA_SUBTLE
			: theme.tokens.COLOR_TOKENS_FILL_INVERTIBLE_PRIMARY_PRIMARY_SUBTLEST};
`;

export const FeatureImage = styled('div')<{ isCompetitor: boolean }>`
	display: flex;
	justify-content: center;
	align-items: flex-start;
	width: 100%;
	flex-shrink: 0;
	background-color: ${({ theme, isCompetitor }) =>
		isCompetitor
			? theme.tokens.COLOR_TOKENS_FILL_INVERTIBLE_NEUTRAL_NEUTRAL_VERY_SUBTLE
			: theme.tokens.COLOR_TOKENS_FILL_INVERTIBLE_PRIMARY_PRIMARY_VERY_SUBTLE};
	border-radius: 16px 16px 0 0;
	overflow: hidden;
`;

export const FeatureImageImg = styled.img`
	display: block;
	max-width: 100%;
	height: auto;
`;

export const FeatureText = styled.div`
	display: flex;
	padding: 48px;
	flex-direction: column;
	align-items: flex-start;
	gap: 12px;
	flex: 1;
	align-self: stretch;

	${media.belowMedium`
		padding: 32px;
	`}
`;

export const Title = styled(ResponsiveText)`
	align-self: stretch;
	text-align: center;
`;

export const Subtitle = styled(ResponsiveText)`
	text-align: center;
`;

export const LogoContainer = styled.div`
	position: absolute;
	bottom: 12px;
	left: 50%;
	transform: translateX(-50%);
	width: 40px;
	height: 40px;

	${media.large`
		display: none;
	`}
`;
